import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./auth/AuthContext";
import { MantisThemeProvider } from "./theme";
import { ConfigProvider } from "./theme/ConfigContext";
import { AdminFeaturesProvider } from "./features/AdminFeaturesContext";
import { ProviderProvider } from "./providers/ProviderContext";
import App from "./App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

// Wraps `<App/>` in ONE MUI `<ThemeProvider>` (Mantis theme, incl. its own single `<CssBaseline/>`)
// + the Mantis-style `ConfigProvider` (drawer open/collapsed state), inside the existing
// `AuthProvider` + `QueryClientProvider` — the reusable layer `apps/admin-web` already proved
// (docs/337 §"the new folder"). `AdminFeaturesProvider` (docs/358-ADMIN-FEATURE-CONFIGURATION.md
// v0) needs no auth/query context of its own — mounted around `<App/>` so both the nav
// (`DrawerContent`, inside `Dashboard`) and the route filter (`App.tsx` itself) can
// `useAdminFeatures()`.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider>
      <MantisThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ProviderProvider>
            <AuthProvider>
              <AdminFeaturesProvider>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </AdminFeaturesProvider>
            </AuthProvider>
          </ProviderProvider>
        </QueryClientProvider>
      </MantisThemeProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
